(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
        $stateProvider
        .state('download-result', {
            parent: 'app',
            url: '/download-result',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.downloadResult'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-result/download-result.html',
                    controller: 'DownloadResultController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadResult');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            },
        });
    }

})();
